import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Footer from "./layout/Footer";
import HeaderLayout from "./layout/HeaderLayout";

const MainLayout = () => {
  const [isContainer, setIsContainer] = useState(window.innerWidth > 2000);

  useEffect(() => {
    const handleResize = () => {
      setIsContainer(window.innerWidth > 2000);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className={isContainer ? "container mx-auto" : "w-full"}>
      <HeaderLayout />
      <Outlet />
      <Footer />
    </div>
  );
};

export default MainLayout;
